/// <reference path="../Route/Router.ts" />
/// <reference path="../Notification/HANotification.ts" />

namespace HA.Core.Service {
    import App = HA.Core.Entity.App;
    import AppService = HA.Core.Service.App;
    import UserService = HA.Core.Service.User;
    import HARouter = HA.Core.Route.HARouter;
    import HAApp = HA.Core.Entity.HAApp;
    import HANotification = HA.Core.Notification.HANotification;
    import Tag = HA.Core.HTML.Tag;
    import HANavigationApp = HA.Core.Entity.HANavigationApp;

    export class WebPage extends Service {
        public showModal(data: Map<any, any>): void {
            data.set("_isModal", true);
            this.reloadApp(data);
        }
        public showApp2(app: App): void {
            this.addApp(app);

            this.showApp(toMap({id: app.getId()}));
        }
        public showAppMenu(data: any): void {
            this.getBody().showAppMenu(data);
        }
        public reloadNav(): void {
            const appData = this.getBody().getAppData();
            appData.set("services", this.getServicesForApp());

            if (appData.get("controllerName")) {
                const me = this;
                this.findApp(toMap({
                    id: appData.get("navigationId"),
                }), true).then((nav: HA.Core.Entity.HANavigationApp) => {
                    me.getBody().reloadNav(nav);
                });
            }
        }
        public reloadApp(data?: Map<any, any>): void {
            let id: any;
            if (!data || !data.has("id")) {
                data = this.getActiveAppData();
                id =  data.get("id") || data.get("_id");
                const app = this.get("curApp");

                if (app) {
                    app.savePosition();
                    data.set("position", app.getPosition());
                    data.delete("app");
                }
            }

            id = id || data.get("id")|| data.get("_id") ;
            const me = this;
            this.removeApp(id, false);
            const history = this.getHistory();
            const last = history.get(history.size - 1);
            if (last && this.isSameApp(last, data)) {
                history.delete(history.size - 1);
            }
            timeout(() => {me.showApp(data);}, 5);
        }

        /**
         * @param data
         */
        public toggleApp(data: Map<any, any>) {
            if (this.isActive(data.get("_id")) || this.isActive(data.get("id"))) {
                this.showPrevious(false);
            } else {
                this.showApp(data);
            }
        }

        public showPrevious(clean = true) {
            if (!clean || this.clean()) {
                const history = this.getHistory();
                if (history.size <= 1) {
                    return;
                }
                history.delete(history.size - 1);
                const data = history.get(history.size - 1);
                history.delete(history.size - 1);
                this.switchToApp(data);
            }

        }
        public toggleQMenu() {
            if (this.get("qmenu")) {
                this.get("qmenu")();
            }
        }

        public setQMenu(qmenu: () => void) {
            this.addToData("qmenu", qmenu);
        }

        public showApp(data: Map<any, any>): void {
            const history = this.getHistory();
            const last = history.get(history.size - 1);
            if (!last || !this.isSameApp(last, data)) {
                if (data.get("id") === "main") {
                    data = this.get("mainApp");
                }
                this.switchToApp(data);
            }
        }

        protected isSameApp(currentData: Map<any, any>, newData: Map<any, any>): boolean {
            if (currentData.get("id") === newData.get("id")) {
                if (newData.has("_id") || currentData.has("_id")) {
                    return currentData.get("_id") === newData.get("_id");
                } else if (newData.has("fid") || currentData.has("fid")) {
                    return currentData.get("fid") === newData.get("fid");
                }

                return true;
            }

            return false;
        }

        protected getServicesForApp() {
            return {
                "ha.service.appManager": this.getBody().getAppManager(),
                "ha.service.user": this.getUserService(),
                "ha.service.webpage": this.getBaseApi(),
                "router": new HARouter(),
            };
        }

        protected getBaseApi() {
            const me = this;
            return {
                isActive: (id: string) => {
                    return me.isActive(id);
                },
                notification: () => {
                    return me.getNotification();
                },
                reloadApp: (data?: any) => {
                    me.reloadApp(data);
                },
                reloadNav: () => {
                    //remove nav
                    me.reloadNav();
                },
                reloadPreviousApp: () => {
                    return me.reloadPreviousApp();
                },
                removeAll: () => {
                    return me.removeAll();
                },
                removeApp: (id: string) => {
                    return me.removeApp(id);
                },
                removeCurrentApp: () => {
                    return me.removeCurrentApp();
                },
                replaceAppId: (id: any, newTd: any) => {
                    me.replaceAppId(id, newTd);
                },
                setMainApp: (d: any) => {
                    me.setMainApp(d);
                },
                showApp: (data: any) => {
                    me.showApp(data);
                },
                showAppMenu: (data: any) => {
                    me.showAppMenu(data);
                },
                showFSApp: (app: App) => {
                    me.showApp2(app);
                },
                showModal: (data: any) => {
                    me.showModal(data);
                },
                showPreviousApp: () => {
                    me.showPrevious();
                },
                toggleQMenu: () => {
                    me.toggleQMenu();
                },
                setQMenu: (qmenu: () => void) => {
                    me.setQMenu(qmenu);
                },
                subscribeToAppInfo: (func: () => void) => {
                    return me.subscribeToAppInfo(func);
                },
                unsubscribeToAppInfo: (subscriptionId: string) => {
                    return me.unsubscribeToAppInfo(subscriptionId);
                },
                toggleApp: (data: any) => {
                    me.toggleApp(data);
                },
            };
        }

        protected replaceAppId(id: any, newTd: any): void {
            let last = this.getActiveAppData();
            if (!last) {
                const history = this.getHistory();
                for (let i = history.size; i >= 0; --i) {
                    const app: Map<any, any> = history.get(i);
                    if (app && app.get("id") === id) {
                        last = app;
                        break;
                    }
                }
            }
            if (last) {
                last.set("id", newTd);
            }
        }

        protected subscribeToAppInfo(func: (info: Map<string, any>) => void): string[] {

            const appId: string = this.get("currAppId") || "main";
            const subscriptionId: string = appId + '_' + (new Date().getTime());

            this.getAppInfoWatchers().set(subscriptionId, func);

            return [appId, subscriptionId];
        }

        protected unsubscribeToAppInfo(subscriptionId: string): void {
            this.getAppInfoWatchers().delete(subscriptionId);
        }

        private getAppInfoWatchers(): Map<string, any> {
            if (this.hasNot("appInfoWatchers")) {
                this.addToData("appInfoWatchers", toMap({}));
            }
            return this.get("appInfoWatchers");
        }

        protected notifyAppInfo(info: Map<string, any>) {
            const appInfoWatchers: Map<string, (info: Map<string, any>) => void> = this.getAppInfoWatchers();
            if (appInfoWatchers.size < 1) {
                return;
            }
            appInfoWatchers.forEach((func: (info: Map<string, any>) => void) => {
                func(info);
            });
        }

        protected getServicesForBody() {
            return {
                "ha.service.webpage": this.getBaseApi(),
                "router": new HARouter(),
            };
        }

        /**
         * @returns {HANotification}
         */
        protected getNotification() {
            return this.get("ha.notification");
        }

        protected removeCurrentApp() {
            let data = this.getActiveAppData();
            if (!data) {
                return;
            }
            if (this.getHistory().size === 1) {
                this.reloadApp(toMap({id : "index"}));
                return;
            }
            this.removeApp(data.get("_id") || data.get("id"));
        }

        protected reloadPreviousApp() {
            this.removeCurrentApp();
            timeout(() => {
                this.reloadApp();
            }, 100);

        }

        protected removeApp(id: string, showPrevious: boolean = true) {
            if (showPrevious && this.isActive(id)) {
                this.showPrevious();
            }
            const app: App = this.getApps().get(id);
            if (app) {
                this.getApps().delete(id);
                getAppService().removeApp(id);
                this.notifyAppInfo(toMap({id : app.getLocalId(), s : -1}));
            }
        }

        protected removeAll() {
            this.getApps().clear();
        }

        protected isActive(id?: string): boolean {
            if (!id) {
                return false;
            }
            const last = this.getActiveAppData();
            return (last && (last.get("_id") === id || last.get("id") === id));
        }

        protected getActiveAppData(): Map<any, any> | undefined {
            const history = this.getHistory();
            return history.get(history.size - 1);
        }

        /**
         *
         * @param app
         */
        protected addApp(app: App) {
            this.getApps().set(app.getId(), app);
        }

        /**
         *
         * @returns {Map}
         */
        protected getApps(): Map<any, any> {
            if (!this.get("apps")) {
                this.addToData("apps", new Map());
            }
            return this.get("apps");
        }

        /**
         *
         * @returns {UserService}
         */
        protected getUserService() {
            if (!this.get("ha.service.user")) {
                this.addToData("ha.service.user", new UserService({
                    services: {
                        "ha.service.webpage": this.getBaseApi(),
                        "router": new HARouter(),
                    },
                },));
            }
            return this.get("ha.service.user");
        }

        /**
         * @param data
         * @param isNavigation
         * @returns {Promise<T>}
         */
        protected findApp(data: Map<any, any>, isNavigation?: boolean) {
            const id = data.get("id") || data.get("_id");
            const app: App = this.getApps().get(id);
            if (app) {
                data.set("ac", (data.get("ac") || 1) + 1);
                return Promise.resolve(app);
            }
            const lid = HA.Core.Entity.Entity.genId();
            data.set("ac", 1);
            data.set("lid", lid);
            if (!isNavigation) {
                this.addToData("currAppId", lid);
            }
            return getAppService().findById(data, isNavigation).then((app2: App) => {
                if (data.has("position") && app2) {
                    app2.setPosition(data.get("position"));
                }
                app2.setLocalId(data.get("lid"));
                return app2;
            });
        }

        protected getHistory(): Map<number, any> {
            return this.get("ha.history");
        }

        /**
         *
         * @returns PageHead
         */
        protected getHead(): PageHead {
            return this.get("ha.service.page.head");
        }

        protected getBody(): HA.Core.Service.PageBodyService {
            return this.get("ha.service.page.body");
        }

        protected _showApp(app: App, data: Map<any, any>) {
            this.addApp(app);
            const history = this.getHistory();
            if (app.isCachable()) {
                history.set(history.size, data);
            }
            if (app.hasUrl()) {
                if (data.get("ac") > 1) {
                    window.history.replaceState(data, app.getName(), app.getUrl());
                } else {
                    window.history.pushState(data, app.getName(), app.getUrl());
                }
            }
            this.getHead().add2Head(app);
            this.getBody().showApp(app);
            this.addToData("curApp", app);
            app.setViewed(true);
            this.notifyAppInfo(toMap({id : app.getLocalId(), s: 1}));
        }

        protected switchToApp(data: Map<any, any>) {
            const me = this;
            if (data.get("app")) {
                this.addApp(data.get("app"));
            }

            this.findApp(data).then((app: App) => {
                const id = app.getId();
                if (id && (id !== data.get("_id") || id !== data.get("id"))) {
                    data.set("id", id);
                }
                me._showApp(app, data);
            }).catch((e) => {
                if ((e instanceof Map) && e.get("error")) {
                    getAppService().processAction(toMap(e.get("error")));
                } else {
                    getAppService().processAction(toMap(e));
                }
            });
        }

        protected initialize(data: any) {
            const me = this;
            super.initialize(data);
            this.addToData("ha.history", new Map());
            this.addToData("ha.notification", new HANotification({debug: false}));
            const pageBody = new PageBodyService({services: this.getServicesForBody()});

            this.addToData("ha.service.page.body", pageBody);
            this.addToData(
                "ha.service.user",
                new UserService(
                    {
                        services: {
                            "ha.service.webpage": this.getBaseApi(),
                            "router": new HARouter(),
                        },
                    },
                ));

            setAppService(new AppService(this.getServicesForApp()));
            setService4App(this.getServicesForApp());
            this.addToData("ha.service.page.head", new PageHead());

            const appData = pageBody.getAppData();
            if ("LoginService" !== appData.get("controllerName")) {
                this.addToData("mainApp", appData);
            }

            if (appData.has("_m")) {
                log({m: appData.get("_m"), d: 5000});
            }
            setAppId(appData.get("haId"));

            if (appData.get("controllerName")) {
                if (appData.get("_1")) {
                    this.getNotification().activateDebugMode();
                } else {
                    this.getNotification().deactivateDebugMode();
                }
                if (appData.get("noReload")) {
                    const element = document.querySelector("[apps]");
                    const navElement = document.querySelector("nav");
                    const appDataClone = toMap(appData);
                    appDataClone.set("tag", new Tag({element: navElement}));
                    appData.set("tag", new Tag({element: element.firstChild}));
                    appData.set("navigation", new HANavigationApp(appDataClone));
                    const app =  new HAApp(appData);
                    this.getHead().add2Head(app);
                    this.getBody().showApp(app);
                    this.addToData("curApp", app);
                    return;
                }
                if (appData.get("app")) {
                    if (appData.get("nav")) {
                        getAppService().createApp(toMap({id: appData.get("navigationId")}), toMap(JSON.parse(appData.get("nav"))), true);
                        appData.delete("nav");
                    }
                    getAppService().createApp(appData, toMap(JSON.parse(appData.get("app"))), false);
                    appData.delete("app");
                }

                if (appData.get("id")) {
                    this.reloadApp(appData);
                } else {
                    me._showApp(new HAApp(appData), appData);
                }
                this.reloadNav();
            } else {
                this.showApp(appData);
            }

            window.onpopstate = (event: PopStateEvent) => {
                this.showApp(event.state);
            };

            this.subscribeToAppInfo(this.get("jsNotification"));
        }

        private clean(): boolean {
            const me = this;
            const apps: Map<string, any> = this.getApps();
            apps.forEach((app: App) => {
                if (!this.isActive(app.getId()) && app.isNotCachable() && app.isViewed()) {
                    me.removeApp(app.getId());
                }
            });

            const histories: Map<any, any> = this.getHistory();
            const newHistories = new Map();
            histories.forEach((data: Map<any, any>, key: string) => {
                const id: string = data.get("id");
                const app: App = apps.get(id);
                if (app && app.isNotNavigable() && app.isViewed()) {
                    histories.delete(key);
                } else {
                    newHistories.set(newHistories.size, data);
                }
            });

            this.addToData("ha.history", toMap(newHistories));
            return true;
        }

        private setMainApp(data: any) {
            this.addToData("mainApp", data);
        }

    }
}
